/* eslint-disable */
"use client";
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SwitchField,
  Text,
  TextAreaField,
  TextField,
  SelectField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { I18n } from "aws-amplify/utils";
import { generateClient } from "aws-amplify/api";
import { getCurrentUser } from "aws-amplify/auth";
import { getRoutine } from "./graphql/queries";
import { updateRoutine } from "./graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            {I18n.get("Add item")}
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children={I18n.get("Cancel")}
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined
              ? I18n.get("Save")
              : I18n.get("Add")}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function RoutineUpdateForm(props) {
  const {
    id: idProp,
    routine: routineModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    danceStyles,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    danceStyleRoutinesId: "",
    name: "",
    videos: [],
    status: false,
    patternList: [],
    owner: [],
  };
  const [username, setUsername] = React.useState("");
  const [danceStyleRoutinesId, setDanceStyleRoutinesId] = React.useState(
    initialValues.danceStyleRoutinesId
  );
  const [name, setName] = React.useState(initialValues.name);
  const [videos, setVideos] = React.useState(initialValues.videos);
  const [status, setStatus] = React.useState(initialValues.status);
  const [patternList, setPatternList] = React.useState(
    initialValues.patternList
  );
  const [owner, setOwner] = React.useState(initialValues.owner);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = routineRecord
      ? { ...initialValues, ...routineRecord }
      : initialValues;
    setDanceStyleRoutinesId(cleanValues.danceStyleRoutinesId);
    setName(cleanValues.name);
    setVideos(cleanValues.videos ?? []);
    setCurrentVideosValue("");
    setStatus(cleanValues.status);
    setPatternList(cleanValues.patternList ?? []);
    setCurrentPatternListValue("");
    setOwner(cleanValues.owner ?? []);
    setCurrentOwnerValue("");
    setErrors({});
  };
  const [routineRecord, setRoutineRecord] = React.useState(routineModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getRoutine.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getRoutine
        : routineModelProp;
      setRoutineRecord(record);
    };
    queryData();
  }, [idProp, routineModelProp]);
  React.useEffect(resetStateValues, [routineRecord]);
  const [currentVideosValue, setCurrentVideosValue] = React.useState("");
  const videosRef = React.createRef();
  const [currentPatternListValue, setCurrentPatternListValue] =
    React.useState("");
  const patternListRef = React.createRef();
  const [currentOwnerValue, setCurrentOwnerValue] = React.useState("");
  const ownerRef = React.createRef();
  const validations = {
    danceStyleRoutinesId: [{ type: "Required" }],
    name: [{ type: "Required" }],
    videos: [{ type: "JSON" }],
    status: [],
    patternList: [{ type: "JSON" }],
    owner: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  const currentAuthenticatedUser = async () => {
    const { username } = await getCurrentUser();
    setUsername(username);
  };
  React.useEffect(() => {
    currentAuthenticatedUser();
  }, []);
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          danceStyleRoutinesId: danceStyleRoutinesId ?? null,
          status: status ?? null,
          patternList: patternList ?? null,
          owner: owner ?? null,
          name: name ?? null,
          videos: videos ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateRoutine.replaceAll("__typename", ""),
            variables: {
              input: {
                id: routineRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "RoutineUpdateForm")}
      {...rest}
    >
      <SelectField
        label={I18n.get("Dance Style")}
        isRequired={true}
        value={danceStyleRoutinesId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              danceStyleRoutinesId: value,
            };
            const result = onChange(modelFields);
            value = result?.danceStyleRoutinesId ?? value;
          }
          if (errors.danceStyleRoutinesId?.hasError) {
            runValidationTasks("danceStyleRoutinesId", value);
          }
          setDanceStyleRoutinesId(value);
        }}
        onBlur={() =>
          runValidationTasks("danceStyleRoutinesId", danceStyleRoutinesId)
        }
        errorMessage={I18n.get(errors.danceStyleRoutinesId?.errorMessage)}
        hasError={errors.danceStyleRoutinesId?.hasError}
        {...getOverrideProps(overrides, "danceStyleRoutinesId")}
      >
        <option value="">Select a dance style</option>
        {danceStyles.map((danceStyle) => (
          <option key={danceStyle.id} value={danceStyle.id}>
            {danceStyle.name}
          </option>
        ))}
      </SelectField>
      <TextField
        label={I18n.get("Name")}
        isRequired={true}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name: value,
              videos,
              status,
              patternList,
              owner,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={I18n.get(errors.name?.errorMessage)}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              name,
              videos: values,
              status,
              patternList,
              owner,
            };
            const result = onChange(modelFields);
            values = result?.videos ?? values;
          }
          setVideos(values);
          setCurrentVideosValue("");
        }}
        currentFieldValue={currentVideosValue}
        label={I18n.get("Videos")}
        items={videos}
        hasError={errors?.videos?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("videos", currentVideosValue)
        }
        errorMessage={I18n.get(errors?.videos?.errorMessage)}
        setFieldValue={setCurrentVideosValue}
        inputFieldRef={videosRef}
        defaultFieldValue={""}
      >
        <TextAreaField
          label={I18n.get("Videos")}
          isRequired={false}
          isReadOnly={false}
          value={currentVideosValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.videos?.hasError) {
              runValidationTasks("videos", value);
            }
            setCurrentVideosValue(value);
          }}
          onBlur={() => runValidationTasks("videos", currentVideosValue)}
          errorMessage={I18n.get(errors.videos?.errorMessage)}
          hasError={errors.videos?.hasError}
          ref={videosRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "videos")}
        ></TextAreaField>
      </ArrayField>
      <SwitchField
        label="Status"
        defaultChecked={false}
        isDisabled={false}
        isChecked={status}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              name,
              videos,
              status: value,
              patternList,
              owner,
            };
            const result = onChange(modelFields);
            value = result?.status ?? value;
          }
          if (errors.status?.hasError) {
            runValidationTasks("status", value);
          }
          setStatus(value);
        }}
        onBlur={() => runValidationTasks("status", status)}
        errorMessage={errors.status?.errorMessage}
        hasError={errors.status?.hasError}
        {...getOverrideProps(overrides, "status")}
      ></SwitchField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              name,
              videos,
              status,
              patternList: values,
              owner,
            };
            const result = onChange(modelFields);
            values = result?.patternList ?? values;
          }
          setPatternList(values);
          setCurrentPatternListValue("");
        }}
        currentFieldValue={currentPatternListValue}
        label={I18n.get("Pattern list")}
        items={patternList}
        hasError={errors?.patternList?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("patternList", currentPatternListValue)
        }
        errorMessage={I18n.get(errors?.patternList?.errorMessage)}
        setFieldValue={setCurrentPatternListValue}
        inputFieldRef={patternListRef}
        defaultFieldValue={""}
      >
        <TextAreaField
          label={I18n.get("Pattern list")}
          isRequired={false}
          isReadOnly={false}
          value={currentPatternListValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.patternList?.hasError) {
              runValidationTasks("patternList", value);
            }
            setCurrentPatternListValue(value);
          }}
          onBlur={() =>
            runValidationTasks("patternList", currentPatternListValue)
          }
          errorMessage={I18n.get(errors.patternList?.errorMessage)}
          hasError={errors.patternList?.hasError}
          ref={patternListRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "patternList")}
        ></TextAreaField>
      </ArrayField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              name,
              videos,
              status,
              patternList,
              owner: values,
            };
            const result = onChange(modelFields);
            values = result?.owner ?? values;
          }
          setOwner(values);
          setCurrentOwnerValue("");
        }}
        currentFieldValue={currentOwnerValue}
        label={I18n.get("Owners")}
        items={owner}
        hasError={errors?.owner?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("owner", currentOwnerValue)
        }
        errorMessage={I18n.get(errors?.owner?.errorMessage)}
        setFieldValue={setCurrentOwnerValue}
        inputFieldRef={ownerRef}
        defaultFieldValue={""}
      >
        <TextField
          label={I18n.get("Owner")}
          isRequired={false}
          isReadOnly={false}
          value={currentOwnerValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.owner?.hasError) {
              runValidationTasks("owner", value);
            }
            setCurrentOwnerValue(value);
          }}
          onBlur={() => runValidationTasks("owner", currentOwnerValue)}
          errorMessage={I18n.get(errors.owner?.errorMessage)}
          hasError={errors.owner?.hasError}
          ref={ownerRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "owner")}
        ></TextField>
      </ArrayField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children={I18n.get("Reset")}
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || routineModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children={I18n.get("Submit")}
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || routineModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
